/**
 * The question type ids of the BizForm.
 */
export const BizFormQuestionTypeIds = {
    shortAnswer: 1,
    longAnswer: 2,
    multiSelect: 3,
    select: 4,
    trueFalse: 5,
    date: 6,
    time: 7,
    dateTime: 8,
    file: 9,
    image: 10,
}

/**
 * The question types of the BizForm.
 */
export const BizFormQuestionTypes = {
    shortAnswer: "Short Answer",
    longAnswer: "Long Answer",
    multiSelect: "Multiple Choice",
    select: "Single Choice",
    trueFalse: "True/False",
    date: "Date",
    time: "Time",
    dateTime: "Date and Time",
    file: "File Upload",
    image: "Image Upload",
}

/**
 * The map of the question type ids to the question types.
 */
export const BizFormQuestionTypeIdTypeMap = {
    [BizFormQuestionTypeIds.shortAnswer]: BizFormQuestionTypes.shortAnswer,
    [BizFormQuestionTypeIds.longAnswer]: BizFormQuestionTypes.longAnswer,
    [BizFormQuestionTypeIds.multiSelect]: BizFormQuestionTypes.multiSelect,
    [BizFormQuestionTypeIds.select]: BizFormQuestionTypes.select,
    [BizFormQuestionTypeIds.trueFalse]: BizFormQuestionTypes.trueFalse,
    [BizFormQuestionTypeIds.date]: BizFormQuestionTypes.date,
    [BizFormQuestionTypeIds.time]: BizFormQuestionTypes.time,
    [BizFormQuestionTypeIds.dateTime]: BizFormQuestionTypes.dateTime,
    [BizFormQuestionTypeIds.file]: BizFormQuestionTypes.file,
    [BizFormQuestionTypeIds.image]: BizFormQuestionTypes.image,
}


export interface BizFormQuestionOption {
    id: number;
    content: string;
    orderIndex: number;
}

export interface BizFormQuestion {
    id: number;
    content: string;
    questionTypeId: number;
    isRequired: boolean;
    description?: string;
    orderIndex: number;
    options: BizFormQuestionOption[];

}


export interface BizFormForm {
    id: string;
    title: string;
    description?: string;
    isPublic?: boolean;
    questions: BizFormQuestion[];
}


export interface BizFormQuestionResponseOption {
    id: number;
    questionResponseId: number;
    optionId: number;
}

export interface BizFormQuestionResponse {
    id: number;
    questionId: BizFormQuestion['id'];
    content?: string;
    optionResponses?: BizFormQuestionResponseOption[];
}

export interface BizFormFormResponse {
    id: string;
    form: BizFormForm;
    questionResponses: BizFormQuestionResponse[];
    createdDateTime: string;
}


export * from './ui/answer-form';
export {default as BizFormAnswerForm} from './ui/answer-form';
export * from './ui/edit-form';
export {default as BizFormEditForm} from './ui/edit-form';
export {BizFormApiProvider, useBizFormApi} from './ui/context/biz-form-api-context';
export type {BizFormApiProviderProps} from './ui/context/biz-form-api-context';
export {BizFormFileUrlsProvider, useBizFormFileUrls} from './ui/context/biz-form-file-urls-context';
export type {BizFormFileUrlsProviderProps, UseBizFormFileUrlsResult} from './ui/context/biz-form-file-urls-context';
export {BizFormApiClient, createBizFormApiClient, injectBizFormApiInterceptors} from './core/services/api';
export {buildBizFormApiEndpoints, normalizeBizFormApiBaseUrl} from './core/models/static/api-endpoints';
export type {BizFormApiEndpoints} from './core/models/static/api-endpoints';
